import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { palette } from 'styled-tools';

const propTypes = {
  active: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  application: PropTypes.bool,
};

const defaultProps = {
  className: null,
  active: false,
  application: false,
};

function Tab({ active, children, className, application }) {
  if (application) {
    return (
      <ContainerTerritary active={active} className={className}>
        {children}
      </ContainerTerritary>
    );
  }
  return (
    <Container active={active} className={className}>
      {children}
    </Container>
  );
}

const ContainerTerritary = styled.li`
  display: block;
  font-size: var(--font-size-xs);
  border-bottom: 0.125rem solid ${({ active }) => (active ? palette('territaryButton', 1) : 'transparent')};
  display: inline-block;
  padding: 0.625rem 0;
  &:hover {
    border-bottom: 0.125rem solid ${palette('territaryButton', 1)};
  }
`;
const Container = styled.li`
  display: block;
  font-size: var(--font-size-xs);
  border-bottom: 0.125rem solid ${({ active }) => (active ? palette('primary', 1) : 'transparent')};
  display: inline-block;
  padding: 0.625rem 0;
  &:hover {
    border-bottom: 0.125rem solid ${palette('primary', 1)};
  }
`;

Tab.propTypes = propTypes;
Tab.defaultProps = defaultProps;

export default styled(Tab)``;
